import React from "react";

const Solutions = () => {
  const solutions = [
    {
      title: "Custom AI Consultancy",
      description:
        "Strategic guidance to identify, prioritize, and implement AI solutions that align with your business model, goals, and industry context."
    },
    {
      title: "Enterprise Training",
      description:
        "Cohort-based and executive training for teams, enabling your workforce to confidently leverage AI tools, workflows, and best practices."
    },
    {
      title: "AI-Powered Analytics",
      description:
        "Advanced analytics and decision intelligence to transform data into actionable insight, powering smarter, faster strategic decisions."
    },
    {
      title: "Process Automation",
      description:
        "Design and deployment of AI-powered automations that streamline operations, reduce manual work, and unlock scalable efficiency."
    },
    {
      title: "Global Support",
      description:
        "Dedicated implementation and advisory support across regions, ensuring smooth rollouts, adoption, and continuous optimization."
    },
    {
      title: "Security & Compliance",
      description:
        "Enterprise-grade governance, security, and compliance frameworks to protect your data and meet regulatory requirements with confidence."
    }
  ];

  return (
    <section className="bg-white text-black py-16 sm:py-24 lg:py-28">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">
            Bespoke Services
          </p>
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-thin mb-6 sm:mb-8">
            Tailored Solutions for <em className="text-gray-500">Your Business</em>
          </h2>
          <p className="text-sm sm:text-base md:text-lg font-light leading-relaxed max-w-3xl mx-auto text-gray-600">
            Our enterprise offerings are designed around your organization&apos;s realities - from strategy and training
            to implementation and long-term governance.
          </p>
        </div>

        {/* Solutions Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
          {solutions.map((solution, index) => (
            <div key={index} className="group h-full">
              <div className="border border-gray-200 bg-white p-6 sm:p-8 h-full hover:border-black transition-all duration-300">
                <div className="mb-4 sm:mb-6">
                  <h3 className="text-lg sm:text-xl font-light tracking-wide mb-2 sm:mb-3 group-hover:text-gray-900 transition-colors">
                    {solution.title}
                  </h3>
                </div>
                <p className="text-gray-600 font-light mb-6 sm:mb-8 leading-relaxed text-sm sm:text-sm">
                  {solution.description}
                </p>
                <div className="w-10 sm:w-12 h-px bg-gray-300 group-hover:bg-black transition-colors" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Solutions;
